import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import { ACCESS_CONFIG, MISSING_INFO_TYPE, NESTED_SIDENAV } from "../strings";

const MissingInfo = () => {
  const { ADMIN_TIER } = ACCESS_CONFIG;
  const missingInfoCount = useSelector((state) => state.missingInfo);
  const {
    leadCount,
    categoryCount,
    customerCount,
    hubspotCount,
    leadUTMCount,
    adAccountCount
  } = missingInfoCount;

  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">Missing Info</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.MISSING_INFO}
            clearParams
            tabs={[
              {
                evKey: MISSING_INFO_TYPE.LEAD_INFO,
                title: "Lead Info",
                popUp: Boolean(leadCount),
                access: ADMIN_TIER
              },
              {
                evKey: MISSING_INFO_TYPE.CATEGORY_INFO,
                title: "Category Info",
                popUp: Boolean(categoryCount),
                access: ADMIN_TIER
              },
              {
                evKey: MISSING_INFO_TYPE.CUSTOMER_INFO,
                title: "Customer Info",
                popUp: Boolean(customerCount),
                access: ADMIN_TIER
              },
              {
                evKey: MISSING_INFO_TYPE.HUBSPOT_INFO,
                title: "Hubspot Info",
                popUp: Boolean(hubspotCount),
                access: ADMIN_TIER
              },
              {
                evKey: MISSING_INFO_TYPE.AD_ACCOUNT,
                title: "AD Account Info",
                popUp: Boolean(adAccountCount),
                access: ADMIN_TIER
              },
              {
                evKey: MISSING_INFO_TYPE.UTM_PARAMETER,
                title: "UTM Parameter",
                popUp: Boolean(leadUTMCount),
                access: ADMIN_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default MissingInfo;
